import React, { useRef, useEffect } from 'react'
import Message from './Message'
import { Message as MessageType } from '../types'
interface ChatMessagesProps {
  user: 'student' | 'tutor'
  translateMessage: (messageId: number, message: string) => void
  reducerMessages: MessageType[]
}

const ChatMessages = ({ user, translateMessage, reducerMessages }: ChatMessagesProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const wrapperRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight
    }
  }, [reducerMessages])

  const mappedMessages = reducerMessages.map((message, index) => {
    const isFirst = reducerMessages[index - 1]?.author !== message.author
    const isLast = reducerMessages[index + 1]?.author !== message.author
    const isSingle = isFirst && isLast
    return {
      ...message,
      author: message.author === user ? 'my' : ('other' as 'other' | 'my'),
      groupMessageType: isSingle
        ? 'single'
        : isFirst
        ? 'first'
        : isLast
        ? 'last'
        : ('middle' as 'first' | 'last' | 'middle' | 'single')
    }
  })

  return (
    <div ref={wrapperRef} className="flex-1 overflow-scroll flex flex-col hide-scrollbar">
      <div
        style={{ maxHeight: wrapperRef.current?.scrollHeight }}
        ref={containerRef}
        className="overflow-scroll flex-1 flex flex-col hide-scrollbar">
        <div className="flex flex-col flex-1 justify-end">
          {mappedMessages.map((item, index) => (
            <Message
              translateMessage={translateMessage}
              key={item.id}
              id={item.id}
              message={item.message}
              type={item.author}
              author={item.author}
              groupMessageType={item.groupMessageType}
              translated={item.translated ?? false}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ChatMessages
